import { useState } from "react";
import { useTranslation } from "react-i18next";
import { requestMagicLink } from "../api/portal";

interface TokenExpiredPageProps {
  onLinkRequested: () => void;
}

export function TokenExpiredPage({ onLinkRequested }: TokenExpiredPageProps) {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      // Always navigate to the "link requested" page regardless of outcome
      // (security: do not reveal whether an email/case exists)
      await requestMagicLink(email.trim()).catch(() => {/* intentionally swallowed */});
    } finally {
      setSubmitting(false);
      onLinkRequested();
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md mx-auto px-4 w-full">
        <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
          <div className="text-4xl mb-4 text-center">🔗</div>
          <h1 className="text-xl font-semibold text-gray-800 mb-2 text-center">
            {t("token_expired_title")}
          </h1>
          <p className="text-gray-500 text-sm mb-6 text-center">
            {t("token_expired_text")}
          </p>

          <form onSubmit={handleSubmit} noValidate>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {t("token_expired_email_label")}
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="deine@email.de"
                required
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <button
              type="submit"
              disabled={submitting || !email.trim()}
              className="w-full py-3 px-4 btn-primary rounded-xl font-semibold transition-colors disabled:cursor-not-allowed"
            >
              {submitting ? "…" : t("token_expired_submit")}
            </button>
          </form>
        </div>

        <footer className="mt-10 text-gray-400 text-xs text-center">WLAN-Hilfe</footer>
      </div>
    </div>
  );
}
